// frontend/src/components/auth/RegisterForm.js
import React, { useState } from 'react';
import { registerUser } from '../../api/auth';
import { useNavigate } from 'react-router-dom';
import { useChat } from '../../context/ChatContext.js';
import './LoginRegister.css';

export default function RegisterForm() {
  const [formData, setFormData] = useState({
    first_name: '',
    last_name: '',
    email: '',
    password: ''
  });
  const [errors, setErrors] = useState({});
  const [message, setMessage] = useState(null);
  const navigate = useNavigate();
  const { updateUser, updateMemory } = useChat();

  const validate = (name, value) => {
    switch (name) {
      case 'first_name':
      case 'last_name':
        if (!/^[A-Za-z\s'-]+$/.test(value)) {
          return 'Only letters, spaces, apostrophes, and hyphens are allowed';
        }
        break;
      case 'email':
        if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value)) {
          return 'Invalid email format';
        }
        break;
      case 'password':
        if (value.length < 8) {
          return 'Password must be at least 8 characters';
        }
        break;
      default:
        return null;
    }
    return null;
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
    setErrors({ ...errors, [name]: validate(name, value) });
  };

  const isFormValid = () => {
    const newErrors = {};
    Object.keys(formData).forEach((key) => {
      const error = validate(key, formData[key]);
      if (error) newErrors[key] = error;
    });
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!isFormValid()) return;
    console.log('🚀 Submitting registration form:', formData);

    try {
      const res = await registerUser(formData);
      console.log('📥 RegisterForm received response:', res);

      const {
        id,
        token,
        shadow_id,
        first_name,
        last_name,
        email,
        access_level,
        trial_start_date,
        trial_expiry_date,
        is_free_override,
      } = res;

      const user = {
        id,
        shadow_id,
        first_name,
        last_name,
        email,
        access_level,
        trial_start_date,
        trial_expiry_date,
        is_free_override,
      };

      const finalUser = { ...user, shadowId: res.shadow_id, token };
      localStorage.setItem('daisy-user', JSON.stringify(finalUser));

      updateUser(finalUser);
      updateMemory('userId', id);
      updateMemory('userName', first_name || 'Friend');

      setMessage(`Welcome, ${first_name}!`);
      navigate('/welcome', {
        state: {
          first_name,
          user_id: id,
          user_email: email,
        },
      });

    } catch (err) {
      setMessage(err.message || 'Registration failed.');
    }
  };

  return (
    <div className="auth-container">
      <form onSubmit={handleSubmit}>
        <h2>Register</h2>
        <input
          name="first_name"
          placeholder="First Name"
          value={formData.first_name}
          onChange={handleChange}
          required
        />
        {errors.first_name && <p className="form-warning">{errors.first_name}</p>}

        <input
          name="last_name"
          placeholder="Last Name"
          value={formData.last_name}
          onChange={handleChange}
          required
        />
        {errors.last_name && <p className="form-warning">{errors.last_name}</p>}

        <input
          name="email"
          placeholder="Email"
          value={formData.email}
          onChange={handleChange}
          required
        />
        {errors.email && <p className="form-warning">{errors.email}</p>}

        <input
          name="password"
          type="password"
          placeholder="Password"
          value={formData.password}
          onChange={handleChange}
          required
        />
        {errors.password && <p className="form-warning">{errors.password}</p>}

        <button type="submit">Register</button>
        {message && <p>{message}</p>}
      </form>

      <p className="auth-links">
      Already have an account? <a href="/login">Login here</a>
      </p>

    </div>
  );
}
